// TBD move to @ds-cps/ui
export const shortenOrgName = (name: string, newLength: number = 50) => {
  let shortName = name;

  if (name?.length > newLength) {
    // In fact max is 256
    shortName = name.slice(0, newLength) + " ...";
  }

  return shortName;
};
